<template>
  <v-container text-xs-center>
    <v-layout row wrap style="margin-left: calc(100% - 812px)">
      <v-toolbar color="white" class="elevation-0" height="40">
        <v-layout flex xs12 md11>
          <v-expand-transition class>
            <div
              class="no-padding"
              xs12
              sm3
              xl4
              v-show="selected.length > 0"
              style="margin-left: 25px; margin-top: 10px"
            >
              <v-btn
                flat
                fab
                small
                @click="editPar"
                v-if="permits['UPDATE_PARENTS']"
              >
                <v-icon> edit </v-icon>
              </v-btn>

              <v-btn
                flat
                fab
                small
                @click="deletePar"
                v-if="permits['DELETE_PARENTS']"
              >
                <v-icon color="primary"> delete </v-icon>
              </v-btn>

              <v-btn
                flat
                fab
                small
                @click="toast.sendFlag = true"
                v-if="permits['SEND_PARENTS']"
                :disabled="selectedToSend.length < 1"
              >
                <v-icon color="primary"> send </v-icon>
              </v-btn>
            </div>
          </v-expand-transition>
        </v-layout>
        <!-- <v-layout flex xs12 md2 style="display: none !important; justify-content: flex-end" v-show="permits['WATCH_PAYMENTS']">
          <v-expand-transition>
            <div flex style="float: right;">
              <v-btn
                style="z-index:99"
                color="gradiente"
                dark
                small
                fab 
                @click="showTableNormal"
              >
                <v-icon>group</v-icon>
              </v-btn>
              <v-btn
                style="z-index:99"
                color="gradiente"
                dark
                small
                fab 
                @click="showTablePayments"
              >
                <v-icon>attach_money</v-icon>
              </v-btn>
            </div>
          </v-expand-transition>
        </v-layout> -->
        <v-speed-dial
          key="1"
          v-model="buttonFab.fab"
          absolute
          bottom
          left
          direction="bottom"
          open-on-hover
          transition="scale-transition"
          style="bottom: 0; z-index: 1"
        >
          <template v-slot:activator>
            <v-tooltip
              right
              v-if="permits['ADD_PARENTS'] && permits['LINK_STUDENTS_PARENTS']"
            >
              <template v-slot:activator="{ on }">
                <v-btn
                  v-model="buttonFab.fab"
                  style="z-index: 99"
                  color="gradiente"
                  dark
                  small
                  fab
                  v-on="on"
                  @click="addPar"
                >
                  <v-icon>{{ toolsPage.iconBtn }}</v-icon>
                </v-btn>
              </template>
              <span>{{ toolsPage.textBtn }}</span>
            </v-tooltip>
          </template>
          <v-tooltip right v-show="!paymentsSelected">
            <v-btn
              fab
              dark
              small
              color="gradiente"
              slot="activator"
              @click="linkPar"
            >
              <v-icon>link</v-icon>
            </v-btn>
            <span>{{ toolsBtn.textBtn }}</span>
          </v-tooltip>
        </v-speed-dial>
      </v-toolbar>
      <v-container style="max-height: 75vh" class="scrollDesign">
        <v-layout row wrap>
          <v-flex ma-1 xs12 class="expandableContainer">
            <v-data-table
              v-model="selected"
              :headers="headers"
              :items="parents"
              :loading="loading"
              hide-actions
              ref="table"
              item-key="id"
              select-all
              no-data-text="No tiene tutores"
              style="max-height: 18vh; overflow-y: scroll"
            >
              <template v-slot:headers="props">
                <tr>
                  <th style="width: 70px; max-width: 70px">
                    <v-checkbox
                      :input-value="props.all"
                      :indeterminate="props.indeterminate"
                      primary
                      color="primary"
                      hide-details
                      @click.stop="toggleAll"
                      v-if="permits['DELETE_PARENTS']"
                    />
                  </th>
                  <th style="width: 70px; max-width: 70px">
                    {{ $t(props.headers[0].langKey) }}
                  </th>
                  <th style="width: 250px; max-width: 250px; min-width: 250px">
                    {{ $t(props.headers[1].langKey) }}
                  </th>
                  <th style="width: 250px; max-width: 250px; min-width: 250px">
                    {{ $t(props.headers[2].langKey) }}
                  </th>
                  <th
                    style="width: 250px; max-width: 250px; min-width: 250px"
                    v-show="!paymentsSelected"
                  >
                    {{ $t(props.headers[3].langKey) }}
                  </th>
                  <th
                    style="width: 160px; max-width: 160px; min-width: 160px"
                    v-show="paymentsSelected"
                  >
                    Dividir pago
                  </th>
                  <th
                    style="width: 230px; max-width: 230px; min-width: 230px"
                    v-show="paymentsSelected"
                  >
                    Monto
                  </th>
                  <th
                    style="width: 160px; max-width: 160px; min-width: 160px"
                    v-show="paymentsSelected"
                  >
                    Notificar pagos
                  </th>
                </tr>
              </template>
              <template v-slot:items="props">
                <td style="width: 70px; max-width: 70px">
                  <v-checkbox
                    v-if="
                      permits['DELETE_PARENTS'] || permits['UPDATE_PARENTS']
                    "
                    color="primary"
                    v-model="props.selected"
                    primary
                    hide-details
                  />
                </td>
                <td style="width: 70px; max-width: 70px">
                  <v-avatar :tile="tile" :size="avatarSize">
                    <v-avatar
                      :tile="tile"
                      :size="avatarSize"
                      color="grey lighten-4"
                      v-if="
                        props.item.imageStorage &&
                        props.item.imageStorage.miniObjUrl
                      "
                    >
                      <img
                        ref="image"
                        :src="props.item.imageStorage.miniObjUrl"
                        alt="avatar"
                      />
                    </v-avatar>
                    <v-icon
                      v-else
                      :color="props.item.gender == 'MALE' ? 'blue' : 'pink'"
                    >
                      account_circle
                    </v-icon>
                  </v-avatar>
                </td>
                <td style="width: 250px; max-width: 250px; min-width: 250px">
                  <CustomTooltipOverflowText>
                    {{ props.item.firstName }}
                  </CustomTooltipOverflowText>
                </td>
                <td style="width: 250px; max-width: 250px; min-width: 250px">
                  <CustomTooltipOverflowText>
                    {{ props.item.lastName }}
                  </CustomTooltipOverflowText>
                </td>
                <td
                  style="width: 250px; max-width: 250px; min-width: 250px"
                  v-show="!paymentsSelected"
                >
                  <CustomTooltipOverflowText>
                    {{ props.item.mail }}
                  </CustomTooltipOverflowText>
                </td>

                <td
                  style="width: 160px; max-width: 160px; min-width: 160px"
                  v-show="paymentsSelected"
                  class="check-box"
                >
                  <v-checkbox
                    color="primary"
                    primary
                    hide-details
                    :value="props.item.split"
                    v-model="props.item.split"
                    @change="checkSplitPush(props.item)"
                    :disabled="parentsEdited.length == 1"
                  />
                </td>

                <td
                  style="width: 230px; max-width: 230px; min-width: 230px"
                  v-show="paymentsSelected"
                >
                  <v-text-field
                    class="payments-center"
                    mask="###"
                    :value="getPercentage(props.item.rate)"
                    name="monto"
                    rows="1"
                    auto-grow
                    suffix="%"
                    :disabled="!props.item.split || parentsEdited.length == 1"
                    @blur="handleBlur($event, props.item)"
                  />
                </td>

                <td
                  style="width: 160px; max-width: 160px; min-width: 160px"
                  v-show="paymentsSelected"
                  class="check-box"
                >
                  <v-checkbox
                    color="primary"
                    primary
                    hide-details
                    :value="props.item.sendNotifications"
                    v-model="props.item.sendNotifications"
                  />
                </td>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>

        <confirm
          :class="!confirm.value ? 'position-no' : ''"
          :value="confirm.value"
          :title="confirm.title"
          :description="confirm.description"
          @desition="desitionDelete"
        />

        <TutorModal
          :class="!modals.parent ? 'position-no' : ''"
          :title="modals.title"
          v-model="modals.parent"
          :parent="select.parent"
          @created="parCreated"
          @updated="parUpdated"
          @onClosed="onCancel"
        />

        <LinkParent
          :class="!modals.LinkV ? 'position-no' : ''"
          :title="modals.title"
          :student="studentId"
          :student-name="studentName"
          :std-parents="parents"
          :value="modals.LinkV"
          @linked="parLinked"
          @close="closeModalLink"
          @onClosed="onCancel"
          v-model="modals.LinkV"
        />

        <!--v-on:desition="desitionDelete"-->
        <loading v-model="working.wLoading" text="Trabajando" />
        <success v-model="toast.success" text="Operación Exitosa" />
        <success v-model="toast.sent" :text="sendResult" />
        <error v-model="toast.failed" text="Ups ocurrió un error" />
        <error
          v-model="toast.failedPercentage"
          text="La suma de los montos deben dar 100%"
        />
        <desition
          @desition="$event ? resendEmail() : ''"
          v-model="toast.sendFlag"
          title="Envío de correo"
          description="Se enviará el correo con el código de registro solo a los usuarios pendientes de registrar.<br/><br/> ¿Deseas continuar con la operación?"
        />
      </v-container>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import { default as confirm, default as desition } from '../../Dialogs/Confirm'
import error from '../../Dialogs/Error'
import loading from '../../Dialogs/Loading'
import success from '../../Dialogs/Success'
import LinkParent from '../../Modals/LinkParentModal.vue'
import TutorModal from '../../Modals/TutorModal.vue'
import CustomTooltipOverflowText from '../../generic/custom_tooltip_overflow_text.vue'

export default {
  components: {
    confirm,
    TutorModal,
    LinkParent,
    loading,
    success,
    error,
    desition,
    CustomTooltipOverflowText,
  },
  props: ['parents', 'studentName', 'studentId', 'permits'],
  data: () => ({
    parentsEdited: [],
    headers: [
      {
        text: 'Foto',
        align: 'center',
        sortable: false,
        value: 'photo',
        langKey: 'students.table_parents.photo',
      },
      {
        text: 'Nombre',
        align: 'left',
        value: 'firstname',
        langKey: 'students.table_parents.first_name',
      },
      {
        text: 'Apellidos',
        value: 'lastName',
        langKey: 'students.table_parents.last_name',
      },
      {
        text: 'Correo',
        value: 'mail',
        langKey: 'students.table_parents.e_mail',
      },
    ],
    selected: [],
    select: {
      parent: null,
    },
    working: {
      wLoading: false,
      wUpdate: false,
    },
    loading: false,
    avatarSize: '30px',
    tile: false,
    modals: {
      title: '',
      parent: false,
      import: false,
      value: false,
      LinkV: false,
    },
    confirm: {
      value: false,
      title: '',
      description: '',
      show: false,
    },
    buttonFab: {
      fab: false,
      hidden: false,
    },
    avatarSize: '30px',
    tile: false,
    gotImages: 0,
    toast: {
      success: false,
      failed: false,
      failedPercentage: false,
      sendFlag: false,
      sent: false,
    },
    sendResult: '',
    imgKey: 0,
    paymentsSelected: false,
    toolsPage: {
      iconBtn: 'add',
      textBtn: 'Crear un tutor',
    },
    toolsBtn: {
      iconBtn: 'add',
      textBtn: 'Ligar un tutor',
    },
  }),
  mounted() {
    this.parentsEdited = this.parents
    this.setLang()
  },
  methods: {
    setLang() {
      this.toolsBtn.textBtn = this.$t('students.table_parents.linking_a_tutor')
      this.toolsPage.textBtn = this.$t('students.table_parents.create_tutor')
    },
    toggleAll() {
      if (this.selected.length) this.selected = []
      else this.selected = this.parents.slice()
    },
    parCreated(event) {
      this.$store
        .dispatch('tutor/addChildToParent', {
          pid: event.id,
          sid: this.studentId,
        })
        .then((res) => {
          this.working.wUpdate = false
          event.image = 'data:image/jpeg;base64,' + event.image
          this.parents.unshift(event)
          this.$refs.table.$forceUpdate()
        })
        .catch((error) => {
          this.working.wUpdate = false
          this.toast.failed = true
          console.log(error)
        })
    },
    parUpdated(event) {
      this.toast.success = true
      this.parents.splice(this.parents.indexOf(this.select.parent), 1, event)

      this.select.parent = null
      this.selected = []
    },
    parLinked(event) {
      this.toast.success = true
      this.parents.unshift(event)
    },
    closeModalLink(event) {
      this.modals.LinkV = event
    },
    addPar(event = null) {
      if (!this.paymentsSelected) {
        this.select.parent = null
        this.modals.title = this.$t('students.tutor_modal.create_tutor')
        this.modals.parent = true
      } else {
        var total = 0
        this.parentsEdited.forEach((parent) => (total += parent.rate))
        if (total == 1.0) {
          var students = {
            id: this.studentId,
            parents: this.parentsEdited,
          }
          this.toast.failedPercentage = false
          this.working.wLoading = true
          this.$store
            .dispatch('student/updateParentPaymentData', students)
            .then((res) => {
              this.working.wLoading = false
              this.working.wUpdate = false
              this.toast.success = true
              this.$refs.table.$forceUpdate()
            })
            .catch((error) => {
              this.working.wLoading = false
              this.working.wUpdate = false
              this.toast.failed = true
              console.log(error)
            })
        } else {
          this.toast.failedPercentage = true
          console.log('error')
        }
      }
    },
    linkPar(event = null) {
      this.modals.title = this.$t(
        'students.modal_link_tutor.add_tutor_to_student'
      )
      this.modals.LinkV = true
    },
    editPar() {
      this.select.parent = this.selected[0]
      this.modals.parent = true
      this.modals.title = this.$t('students.tutor_modal.edit_tutor')
    },
    deletePar() {
      this.confirm.description =
        'Esta a punto de deligar ' +
        (this.selected.length == 1
          ? 'a ' + this.selected[0].firstName + ' ' + this.selected[0].lastName
          : this.selected.length + ' tutores.\n') +
        ' ¿Está seguro que desea realizar dicha acción?'
      this.confirm.value = true
      this.confirm.title = 'Confirmación'
      this.confirm.show = true
      this.confirm.value = true
    },
    desitionDelete(e) {
      if (e) {
        this.deleteParents()
      } else {
        this.confirm.value = false
      }
    },

    deleteParents() {
      this.working.wLoading = true
      if (this.selected.length > 0) {
        this.$store
          .dispatch('tutor/removeChildToParents', {
            sid: this.studentId,
            pars: this.selected,
          })
          .then((response) => {
            for (var e in this.selected) {
              this.parents.splice(this.parents.indexOf(this.selected[e]), 1)
            }
            this.selected = []
            this.working.wLoading = false
            this.toast.success = true
            this.confirm.value = false
            this.$forceUpdate()
          })
          .catch((error) => {
            this.working.wLoading = false
            this.toast.failed = true
            this.confirm.value = false
            console.log(error)
          })
      }
    },
    closeModal(event) {
      this.modals.parent = false
    },
    closeLinkModal(e) {
      this.modals.LinkV = false
    },
    showTableNormal() {
      this.paymentsSelected = false
      this.toolsPage.iconBtn = 'add'
      this.toolsPage.textBtn = 'Ligar un tutor'
    },
    showTablePayments() {
      this.paymentsSelected = true
      this.toolsPage.iconBtn = 'save'
      this.toolsPage.textBtn = 'Guardar'
    },
    getPercentage(value) {
      if (this.parentsEdited.length == 1) {
        return 100
      }
      return parseInt(value * 100)
    },
    checkSplitPush(parentList) {
      if (!parentList.split) {
        for (var index in this.parentsEdited) {
          if (this.parentsEdited[index].id == parentList.id) {
            parentList.rate = 0
          }
        }
      }
    },
    handleBlur(e, parentList) {
      parentList.rate = e.target.value / 100
    },
    onCancel() {
      this.modals.parent = false
      this.modals.LinkV = false

      this.$forceUpdate()
    },
    handleKeyDown(e) {
      //method to handle the keypress
      if (e.code === 'Escape') {
        this.onCancel()
      }
    },

    resendEmail() {
      this.working.wLoading = true
      let request = { ids: this.selectedToSend.map((p) => p.id) }
      // let request = { ids:this.selected.map(p => p.id) };

      this.$store
        .dispatch('tutor/resendEmailV2', request)
        .then((response) => {
          this.working.wLoading = false
          this.sendResult =
            'El correo se envió a ' +
            response.data.entity.success +
            ' de ' +
            response.data.entity.found +
            ' tutores.'
          this.toast.sent = true
          this.$forceUpdate()
        })
        .catch((error) => {
          console.log(error)
          this.working.wLoading = false
          this.toast.failed = true
        })
    },
  },
  created() {
    window.addEventListener('keydown', this.handleKeyDown) //will attach the event listener to the whole window when the component is created
  },
  destroyed() {
    window.removeEventListener('keydown', this.handleKeyDown) //will detach the event listener once the component is destroyed
  },
  watch: {
    getLang() {
      this.setLang()
    },
  },
  computed: {
    ...mapGetters(['getLang']),
    selectedToSend() {
      return this.selected.filter((p) => !p.pWchanged)
    },
  },
}
</script>

<style scoped>
::v-deep .v-datatable.v-table > tbody {
  max-height: initial !important;
  min-height: initial !important;
}
</style>

<style>
.check-box .v-input--checkbox {
  padding-left: 40% !important;
}
.no-padding {
  padding-left: 10%;
}
.position-no {
  position: absolute;
  top: 0px;
  right: 0px;
  z-index: -1;
}

.expandableContainer {
  border-style: solid;
  border-color: #e6e6e6;
  border-radius: 15px;
  border-width: 2px;
}

.payments-center .v-text-field__slot input {
  text-align: center !important;
}
</style>
